import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form'
import update from 'immutability-helper';

import merge from 'lodash/merge'

import browser from './modules/browser';
import cart from './modules/cart';
import basket from './modules/basket';
import products from './modules/products';
import {PAGINATION_TYPES as NEWS_PAGINATION_TYPES} from './modules/news';
import user from './modules/user';

import paginate from './modules/paginate';


import { ADD_ENTITIES, SET_ENTITIY } from './actions';

const entityState = {
  invoices: {},
  news: {},
  subjects: {},
  banks: {},
  objects: {},
  products: {},
  districts: {},
  gallery: {}
}

const entities = (state=entityState, action) => {
  switch (action.type) {
    case ADD_ENTITIES:
      return merge({}, state, action.payload)

    case SET_ENTITIY:
      return update(state, {
        [action.collection]: {
          [action.id]: {
            $set: action.entity
          }
        }
      })

    default:
      return state;
  }
}

const pagination = combineReducers({
  news: paginate({ types: NEWS_PAGINATION_TYPES }),
})


export default combineReducers({
  pagination,
  entities,
  products,

  user,
  basket,
  browser,
  cart,
  router: routerReducer,
  form: formReducer
});



// WEBPACK FOOTER //
// ./src/redux/index.js